import { useState, useEffect } from 'react';

export function useScroll() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastYPos, setLastYPos] = useState(0);
  const [shouldShowNav, setShouldShowNav] = useState(true);

  useEffect(() => {
    function handleScroll() {
      const yPos = window.scrollY;
      const isScrollingUp = yPos < lastYPos;

      setIsScrolled(yPos > 50);
      setShouldShowNav(isScrollingUp || yPos < 50);
      setLastYPos(yPos);
    }

    window.addEventListener('scroll', handleScroll, false);

    return () => {
      window.removeEventListener('scroll', handleScroll, false);
    };
  }, [lastYPos]);

  return { isScrolled, shouldShowNav };
}
